export default "__VITE_ASSET__CA_mCkSB__"